exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".ItemLabel__itemLabel___3owWA {\n    position: absolute;\n    color: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["inverseMainTextColour"] + ";\n    background-color: rgba(33,33,33,0.50);\n    border-radius: 0.1rem;\n    padding: 0.25rem;\n    bottom: 1rem;\n    font-size: 0.7rem;\n    text-align: center;\n    left: 0;\n    right: 0;\n    margin: auto;\n    width: 80%;\n}", ""]);

// exports
exports.locals = {
	"inverseMainTextColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["inverseMainTextColour"] + "",
	"itemLabel": "ItemLabel__itemLabel___3owWA"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/ItemLabel.icss
// module id = 1485
// module chunks = 0